import Phaser from 'phaser';
import { store } from '../stores/mainStore';
import { i18n } from '../i18n';
import { createCircleAvatar, shadowTextStyle, updateMasks} from './uiElements';
import {DICE_TYPE, addHandName, scorecardDiceRow} from './scoreCardElements';
import {getTimelineDuration, isValidHand} from './helpers';
import {history} from '../history';

export class OneHandResult extends Phaser.GameObjects.Container {
	constructor(_scene, match, _m) {
		const config = _scene.game.config;
		const m = _m;

		const myHand = match.hands[0];
		const oppHand = match.opponent.hands[0];
		console.log('8532 HANDS :: my =', myHand, 'opp =', oppHand, '\n\t dices :: my =', myHand.diceFaces, 'opp =', oppHand.diceFaces, '\n\t strs =', myHand.handStrength, 'opp =', oppHand.handStrength)

		let isWin = false, isTie = true
		if(myHand.handStrength === -1) {
			isWin = false;
			isTie = oppHand.handStrength === -1
		} else if(oppHand.handStrength === -1) {
			isWin = true;
			isTie = false;
		} else {
			isWin = myHand.handStrength === 'win';
			isTie = myHand.handStrength === 'tie';
			/* const myWW = myHand.handStrength.split('_').map(v => ~~v).slice(0, -1);
			const oppWW = oppHand.handStrength.split('_').map(v => ~~v).slice(0, -1);
			for(let i = 0; i< myWW.length; i++) {
				if(myWW[i] !== oppWW[i]) {
					isTie = false;
					isWin = myWW[i] > oppWW[i];
					break
				}
			} */
		}
		console.log('8532 tie=', isTie, 'win =', isWin)

		const dimPanel = _scene.add.sprite(config.width/2, config.height/2, 'dimPanel')
			.setDisplaySize(config.width, config.height)
			.setDepth(3);
		m.scoreCardElements.push(dimPanel);

		const windowY = config.height * 0.5;
		const panelScale = Math.min(
			0.85 * m.config.width / 614,
			0.75 * m.config.height / 800,
		)
		const bkg = _scene.add.sprite(0,0, 'resultPanel').setScale(panelScale);
		const panelW = bkg.getBounds().width; 
		const panelH = 800/614 *panelW;
		const diceSize = 0.35*panelW / 5, margin = 0.05* panelW, diceY = -0.05*panelH;
		const avaX = margin + 2.5*diceSize; 
		const avaSize = 0.27*panelW, avaY = -0.23*panelH;
		const yPrize = 0.1*panelH, yBalance = 0.277*panelH;
		const fsPrize = 0.075*panelH, fsBalance = 0.05*panelH

		super(_scene, config.width/2, windowY);
		_scene.add.existing(this);

		const bannerText = _scene.add.text(0, -0.43*panelH, 
			i18n.t('results').toUpperCase(), 
			{font: '900 70px ' + m.ui.dodFontFamily, fill: '#ffffff',
			shadow: { offsetX: 0, offsetY: 6, color: '#7d1b0080', blur: 0, stroke: false, fill: true }}
		).setOrigin(0.5);

		const myAvatar = createCircleAvatar(-avaX, avaY, avaSize, 'profile_default', i18n.t('You'));
		const oppAvatar = createCircleAvatar(avaX, avaY, avaSize, 'oppAvatar', store.activeMatch.opponent.name);

		const myTray = scorecardDiceRow(DICE_TYPE.QUESTION, -avaX, diceY, null, diceSize);
		const oppTray = scorecardDiceRow(DICE_TYPE.QUESTION, avaX, diceY, null, diceSize);

		const myHandName = addHandName(-avaX, diceY + diceSize, myHand, 40, 5*diceSize);
		const oppHandName = addHandName(avaX, diceY + diceSize, oppHand, 40, 5*diceSize);

		const addCoin = (x, y) => m.scene.add.image(x, y, 'coin').setScale(.1*panelW / 256);
		const prizeLabel = m.scene.add.text(0, 0, i18n.t('prize_colon'), shadowTextStyle(700, fsPrize))
			.setOrigin(0, 0.5);
		const prizeCoin = m.scene.add.image(prizeLabel.getBounds().right + 20, 0, 'multi_'+store.multiplier)
			.setScale(.1*panelW / 500).setOrigin(0, 0.5);
		const prizeTxt = m.scene.add.text(prizeCoin.getBounds().right + 15, 0, '', shadowTextStyle(700, fsPrize))
			.setOrigin(0, 0.5)
			.setText(store.truncateValue(store.prize));
		const prizeCont = m.scene.add.container(0, yPrize, [prizeLabel, prizeCoin, prizeTxt])
			.setVisible(isWin)
		prizeCont.setScale(Math.min(1, 0.37* 2*panelW / prizeCont.getBounds().width))
			.setX(Math.min( -0.37*panelW, -prizeCont.getBounds().width / 2))

		const lostLabel = m.scene.add.text(0, yPrize, 
			i18n.t(isTie ? 'tie_result': 'lost_result'), 
			shadowTextStyle(700, 0.7*fsPrize))
			.setStyle({align: 'center'})
			.setOrigin(0.5).setVisible(!isWin);

		const balanceLabel = m.scene.add.text(-0.36 *panelW, 0.24*panelH, i18n.t('balance'), shadowTextStyle(500, 40)).setOrigin(0, 1);
		const balanceCoin = addCoin(-0.38*panelW, yBalance).setOrigin(0.5);
		const balanceTxt = m.scene.add.text(-0.3 *panelW, yBalance, store.truncateValue(store.balance), shadowTextStyle(600, fsBalance)).setOrigin(0, 0.5);

		const handHelp = m.scene.add.sprite(0.35* panelW, yBalance, 'helpBtn')
			.setInteractive().setScale(m.oldAssetScaleFactor * 0.7)
			.on('pointerdown', () => {
				handHelp.downOnHelp = true;
				gameSetTimeout(() => {
					handHelp.downOnHelp = false
					handHelp.y = yBalance;
				}, 1000);
				handHelp.y += 5;
				m.playAudio('poop');
			})
			.on('pointerup', () => {
				handHelp.y = yBalance;
				if (handHelp.downOnHelp === true) {
					m.playAudio('pop');
					store.showResultHandExplain = true;
				}
			})
			.on('pointerout',() => {
				handHelp.y = yBalance;
			})

		this.add([bkg, bannerText,
			...Object.values(myAvatar),
			...Object.values(oppAvatar),
			myTray, oppTray,
			myHandName, oppHandName,
			//prizeLabel, prizeCoin, prizeTxt, // prizeCoinPuff,
			lostLabel, prizeCont,
			balanceLabel, balanceCoin, balanceTxt,
			handHelp
		]).setDepth(7);
		
		const showTime = 500, coinTime = 1000;
		const addHandToTimeline = (tl, type, x, y, hand, offset, sound = '') => {
			const result = scorecardDiceRow(type, x, y, hand, diceSize);
			const animation = scorecardDiceRow(type, x, y, hand, diceSize);
			this.add([result, animation]);

			tl.add({ targets: [result], duration: showTime,
				alpha: {start: 0, to: 1},
				offset: offset,
				onStart: () => {
					if(sound !== '')
						m.playAudio(sound);
						//setTimeout(m.playAudio, 100, sound)
				}
			});
			tl.add({ targets: [animation], duration: showTime,
				alpha: {start: 0, from: 1, to: 0},
				scale: {from: 1, to: 2},
				offset: '-='+showTime
			});
			return tl;
		}

		const maskMove = () => {updateMasks([myAvatar.avatar, oppAvatar.avatar], avaSize)}
		const hideTween = targets => {return {
			targets, duration: showTime,
			alpha: {from: 1, to: 0},
		}}
		const showTween = targets => {return {
			targets, duration: showTime,
			alpha: {start: 0, to: 1},
		}}

		const createStarsContainer = (centerX, y, targetSize) => {
			var starsContainer = m.scene.add.container(centerX, y);
			starsContainer.setDepth(5);
			var yOffsets = [40, 12, 2, 12, 40];
			var xOffsets = [-targetSize * 0.5, -targetSize * 0.3, 0, targetSize * 0.3, targetSize * 0.5];
			for (let i = 0; i < 5; i++) {
				let lilStar = m.scene.add.sprite(
					xOffsets[i] * 1.2,
					-targetSize * 0.7 + yOffsets[i] * m.scaleFactor,
					'common',
					'small_star.png'
				);
				starsContainer.add(lilStar);
				//lilStar.setScale(0.42 * m.scaleFactor);
				m.scoreCardElements.push(lilStar);
				let rotTween = m.scene.tweens.add({
					targets: [lilStar],
					angle: 360,
					ease: 'Linear',
					duration: 2000,
					repeat: -1,
				});
				m.scoreCardTweens.push(rotTween);
			}
			m.scoreCardElements.push(starsContainer);
			return starsContainer;
		}
		const addWinnerStars = () => {
			const timestamp = getTimelineDuration(flow) + 50;
			const addStars = x => {
				const cont = createStarsContainer(x, avaY, avaSize);
				cont.list.forEach(ch => ch.setAlpha(0).setScale(0.75*panelScale))
				this.add(cont);
				return {targets: cont.list, duration: 500,
					alpha: {from: 0, to:1},
					delay: _scene.tweens.stagger(100),
					offset: timestamp,
					onStart: () => {
						setTimeout(m.playAudio, 250,
							(isTie || isWin) ? 'TotalScore_TahDah' : 'finalLosing'
						);
					}
				}
			}
			if(isWin /* || (isTie && myHand.handStrength !== -1) */)	
				flow.add(addStars(-avaX));
			//if((!isWin || isTie) && oppHand.handStrength !== -1)	
			if(!isWin && !isTie)	
				flow.add(addStars(avaX));
		}

		const counterAnim = (txt, from, to, duration = coinTime) => { return {
			targets: [txt], duration, 
			value: {from, to, ease: 'Linear'},
			onUpdate: () => {txt.text = store.truncateValue(Math.round(txt.value))}
		}}

		let flow =_scene.tweens.timeline({ onComplete: () => {
			store.balance += isWin ? store.prize : isTie ? store.prize/2 : 0
		}})
			// window motion
			.add({targets: [dimPanel], duration: 400, alpha: {from: 0, to: 1}})
			.add({targets: [this], duration: 400, offset: 0,
				y: {from: -config.height/4, to: windowY + 60},
			})
			.add({targets: [this], duration: 100, y: windowY})
			.add({targets: [
					...Object.values(myAvatar),
					...Object.values(oppAvatar)
				], duration: 200, delay: 50,
				alpha: {start: 0, to: 1},
				onStart: maskMove
			});

		const prizeCoinRect = prizeCoin.getBounds();

		// show my hand
		flow = addHandToTimeline(flow, DICE_TYPE.STROKE, -avaX, diceY, myHand, '+=50', isValidHand(myHand) ? 'correctHand' : 'noHand')
			.add({...hideTween(myTray), offset: '-='+showTime})
			.add({...showTween([myHandName]), offset: '-='+showTime})
			.add({ targets: this, duration:showTime,
				value: {from:0, to: myHand.score, ease: 'Linear'},
				// onUpdate: () => {xpNum.text = Math.round(this.value)},
				offset: '-='+showTime,
			})

		// show his hand
		flow = addHandToTimeline(flow, DICE_TYPE.STROKE, avaX, diceY, oppHand, '+=50', 
			isValidHand(oppHand) ? 'correctHand' : 'noHand')
			.add({...hideTween(oppTray), offset: '-='+showTime})
			.add({...showTween([oppHandName]), offset: '-='+showTime})

		const timeStamp = getTimelineDuration(flow) + 200;
		// show win hand
		if(isWin || isTie)
			flow = addHandToTimeline(flow, DICE_TYPE.BONUS, -avaX, diceY, myHand, timeStamp, 
				(isTie || isWin) ? 'correctHand' : ''
				//isTie ? 'scoreTie' : isWin ? 'scoreWin' : ''
			)
		if(!isWin || isTie)
			flow = addHandToTimeline(flow, DICE_TYPE.BONUS, avaX, diceY, oppHand, timeStamp, !isWin && !isTie ? 'correctHand' /* 'scoreLose' */ : '')

		// show win anims
		addWinnerStars()
		
		// show coins anim
		const myRect = myAvatar.avatar.getBounds()
		const balRect = balanceCoin.getBounds()
		const oppRect = oppAvatar.avatar.getBounds()
		if(isTie) {
			flow.add({...counterAnim(balanceTxt, 
					store.balance, store.balance + store.prize/2),
				offset: '-=' + 0,
				onStart: () => {
					const time = Math.min(0.01*store.prize, coinTime / 1000)
					store.coinAnimation = {
						from: {x:prizeCoinRect.left, y:prizeCoinRect.top}, 
						to: {x: myRect.centerX, y: myRect.centerY},
						time, value: 0, coins: 3
					}
					store.coinAnimation2 = {
						from: {x:prizeCoinRect.left, y:prizeCoinRect.top}, 
						to: {x: oppRect.centerX, y: oppRect.centerY},
						time, value: 0, coins: 3
					}
					m.playAudio('Transition_subtleWhoosh_v2a');
				}
			})
		} else if (isWin) {
			flow.add({...counterAnim(balanceTxt, 
					store.balance, store.balance + store.prize),
				offset: '-=' + 0,
				onStart: () => {
					const time = Math.min(0.01*store.prize, coinTime / 1000)
					store.coinAnimation = {
						from: {x:prizeCoinRect.left, y:prizeCoinRect.top}, 
						to: {x: balRect.left, y: balRect.top},
						time, value: 0, coins: 3
					}
					m.playAudio('Transition_subtleWhoosh_v2a');
				}
			})
		/* } else {
			flow.add({...hideTween([prizeLabel, prizeCoin, prizeTxt]), offset: '-='+showTime})
				.add({...showTween(lostLabel), offset: '-='+showTime}) */
		}


		// show button
		const onClose = () => {	
			store.activeMatch = null;
			return store.sendSeen();
		}
		const playAgain = m.ui.createButton(
			'btn_play_hand.png', 0.5*m.config.width, 
			bkg.getBounds().bottom - 0.25*m.ui.defaultButtonHeight,
			m.config.width *0.5,
			m.ui.defaultButtonHeight * 1.35,
			store.truncateValue(store.bet) + " " + i18n.t('rebet'),
			()=> {
				onClose().then(() => {
					store.getMe().then(() => {
						store.isImmediateRematch = true;
						store.createMatch(store.bet).then(gameId => {	
							history.push(`/game/${gameId}/play`);
						})							
					})
				})
			}, "green", "box_prize_n_wager_wager_coin.png"
		).setAlpha(0)
		const newBet = m.ui.createButton(
			'btn_new_bet.png', 0.5*m.config.width, 
			playAgain.getBounds().bottom + 0.5*m.ui.defaultButtonHeight,
			m.config.width *0.5,
			m.ui.defaultButtonHeight * 1.35,
			'new-bet',
			()=> {
				onClose().then(() => {
					store.modal = 'stakeSelect';
				})
			}
		).setAlpha(0)
		flow.add({...showTween([playAgain, newBet]), offset: getTimelineDuration(flow)})
		flow.play();
	}
}	